module.exports = "/images/vendor/lightbox2/dist/prev.png?84b76dee6b27b795e89e3649078a11c2";